import { render } from "./ui-notification.vue?vue&type=template&id=03090665&scoped=true"
import script from "./ui-notification.vue?vue&type=script&lang=ts"
export * from "./ui-notification.vue?vue&type=script&lang=ts"

import "./ui-notification.vue?vue&type=style&index=0&id=03090665&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-03090665"

export default script